export interface FeaturePickerItem {
  value: string;
  label: string;
  shortLabel?: string | null;
  categories?: Array<
    | {
        value: string;
        label: string;
        shortLabel: string;
      }
    | string
  >;
  children?: Array<FeaturePickerItem>;
}
